import { instance } from "./baseClient";

export const getTextResource = async (language) => {
  if (language)
    return await instance
      .get(`/TextResources?language=${language}`)
      .then((res) => res.data);
  return await instance.get(`/TextResources`).then((res) => res.data);
};
